import React from 'react';
import { render } from 'react-dom';
import Component from './component';
import FilterContainer, { Provider } from 'js/containers/filter';
import './css/index.css';

export default class {

    static name = 'data-release-archive-filter';

    constructor( config ) {

        this.config = config;
        this.wrapper = config.element;
        this.data = config.attributes.data;
        this.container = new FilterContainer( this.data.filters );

    }

    ready() {

        render(
            <Provider inject={ [ this.container ] }>
                <Component
                    config={ this.config }
                    data={ this.data }
                    container={ this.container }
                />
            </Provider>,
            this.wrapper
        );

    }

}